"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHiking = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M15.5 4a2 2 0 11-4 0 2 2 0 014 0zM13.014 13.6l.577-2.595.702.702a1 1 0 00.982.254L18 11.183V21a1 1 0 102 0V9a1 1 0 10-2 0v.103l-2.709.774c-.671-.672-1.52-2.131-2.466-2.341a1.5 1.5 0 00-1.79 1.139l-.942 4.243-2.06 7.828a1 1 0 101.934.509l1.61-6.117 2.154 1V21a1 1 0 102 0v-5.5a1 1 0 00-.579-.907l-2.138-.992zM9.467 8.123c.104-.542-.255-1.08-.806-1.048a4.002 4.002 0 00-3.69 3.237l-.347 1.805a1 1 0 00.805 1.173l1.969.354a1 1 0 001.158-.796l.91-4.725z' }))); };
exports.default = SvgHiking;
//# sourceMappingURL=Hiking.js.map